__turbopack_context__.v({
  "icon": "label-module-scss-module__ZerUdW__icon",
  "label": "label-module-scss-module__ZerUdW__label",
  "loading": "label-module-scss-module__ZerUdW__loading",
  "shine": "label-module-scss-module__ZerUdW__shine",
});
